import { Action } from 'redux';

import { UpdateUserNotificationsStatus, UpdateUserNotificationsStatusSucceeded } from '../../../app/actions/AppActionTypes';
import { isActionFactory } from '../../../app/actions/isActionFactory';

export interface UpdateUserNotificationsStatusAction extends Action {
    notificationIds: string[];
    isRead: boolean;
 }

export interface UpdateUserNotificationsStatusSucceededAction extends Action {
    notificationIds: string[];
    isRead: boolean;
}

export function updateUserNotificationsStatusAction(ids: string[], isRead: boolean): UpdateUserNotificationsStatusAction {
  return {
    type: UpdateUserNotificationsStatus,
    notificationIds: ids,
    isRead: isRead
  };
}

export function updateUserNotificationsStatusSucceededAction(ids: string[], isRead: boolean): UpdateUserNotificationsStatusSucceededAction {
  return {
    type: UpdateUserNotificationsStatusSucceeded,
    notificationIds: ids,
    isRead: isRead
  };
}

export const isUpdateUserNotificationsStatusAction = isActionFactory<UpdateUserNotificationsStatusAction>(UpdateUserNotificationsStatus);

export const isUpdateUserNotificationsStatusSucceedAction = isActionFactory<UpdateUserNotificationsStatusSucceededAction>(UpdateUserNotificationsStatusSucceeded);